import { styled } from "@mui/material";
import { Moon, Sun } from "lucide-react";
import { useThemeProvier } from "@styles/useThemeProvider";
import { tokens } from "@styles/tokens";

/** Light/dark toggle, backed by the app-wide theme context. */
export function ThemeToggle() {
  const { isDarkMode, toggleTheme } = useThemeProvier();
  return (
    <Toggle
      type="button"
      onClick={toggleTheme}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      {isDarkMode ? <Sun size={18} strokeWidth={1.75} /> : <Moon size={18} strokeWidth={1.75} />}
    </Toggle>
  );
}

const Toggle = styled("button")(({ theme }) => ({
  display: "grid",
  placeContent: "center",
  width: 38,
  height: 38,
  cursor: "pointer",
  borderRadius: tokens.radius.full,
  border: `1px solid ${theme.skuey.border}`,
  backgroundColor: theme.skuey.surface,
  color: theme.skuey.muted,
  transition: "color .15s ease, border-color .15s ease",
  "&:hover": {
    color: theme.skuey.ink,
    borderColor: theme.skuey.borderStrong,
  },
}));
